import * as React from 'react';

import {gameAutoplayComponent, GameAutoplayComponentConfigurationContext} from './gameAutoplayComponentPortraitConfiguration';

const withGameAutoplayComponentConfiguration = <P extends object>(
    WrappedComponent: React.ComponentType<P>): React.FC<P> => {
    const HOC = (props: any): React.ReactElement => (
        <GameAutoplayComponentConfigurationContext.Consumer>
            {(auth: any): React.ReactElement => {
                return (
                    <WrappedComponent {...props}{...gameAutoplayComponent}/>
                );
            }}
        </GameAutoplayComponentConfigurationContext.Consumer>
    );

    HOC.displayName = `withAuthentication(${WrappedComponent.displayName || WrappedComponent.name})`;
    HOC.WrappedComponent = WrappedComponent;
    return HOC;
};

export default withGameAutoplayComponentConfiguration;